import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Discussion_Renderer.scss';
import { _className, Button, ComponentSync, dispatcher_urlParamsChanged, EventType_Create, EventType_Update, LL_H_C, LL_V_C, LL_V_L, LL_V_R, ModuleFE_MouseInteractivity, ModuleFE_RoutingV2, mouseInteractivity_PopUp, SimpleListAdapter, stopPropagation, TS_TextArea } from '@nu-art/thunderstorm-frontend/index';
import { __stringify, arrayToMap, BadImplementationException, dbObjectToId, filterInstances, sortArray } from '@nu-art/ts-common';
import { ModuleFE_Account } from '@nu-art/user-account-frontend/index';
import { Message_Renderer } from '../message/Message_Renderer.js';
import { ICONS } from '@app/styles';
import { renderParticipantIcon } from '../renderer-utils/const.js';
import { TS_SimpleDialog } from '@nu-art/thunderstorm-frontend/components/TS_Dialog/TS_SimpleDialogue';
import { DeleteConfirmation_Body } from './delete-confirmation/DeleteConfirmation_Body.js';
import { ModuleFE_User } from '../../../_entity.js';
import { ModuleFE_Message, ModuleFE_Topic } from '@nu-art/ts-messaging-frontend';
import { CollectionEntityMapper } from '@app/hcs-frontend/entities/CollectionEntityMapper';
import { ModuleFE_Discussion, } from '@app/hcs-frontend';
export class Discussion_Renderer extends ComponentSync {
    __onDiscussionsUpdated(...params) {
        if (params[0] === EventType_Create || params[0] === EventType_Update)
            if (params[1].topicId === this.props.discussion.topicId)
                this.reDeriveState();
    }
    __onMessagesUpdated(...params) {
        if (params[0] === EventType_Create || params[0] === EventType_Update)
            if (params[1].topicId === this.props.discussion.topicId)
                this.reDeriveState();
    }
    deriveStateFromProps(nextProps, state) {
        const participants = this.getParticipantsByAuditorEmails(ModuleFE_Message.cache.filter(msg => msg.topicId === nextProps.discussion.topicId).map(msg => msg._auditorId));
        const dbMessages = sortArray(ModuleFE_Message.cache.filter(msg => msg.topicId === nextProps.discussion.topicId), msg => msg.__created, false);
        return {
            ...state,
            participants: participants,
            accountsMap: arrayToMap(filterInstances(participants.accounts), dbObjectToId),
            messages: dbMessages,
            discussionOpened: state.discussionOpened || false,
            addingNewMessage: state.addingNewMessage || false
        };
    }
    getParticipantsByAuditorEmails(emails) {
        const accounts = emails.reduce((accounts, email) => {
            const dbAccount = ModuleFE_Account.cache.find(acc => email === acc.email);
            if (!dbAccount || accounts.find(account => account.email === dbAccount?.email))
                return accounts;
            accounts.push(dbAccount);
            return accounts;
        }, []);
        // const accounts = emails.map(email => ModuleFE_Account.cache.find(acc => email === acc.email));
        const users = accounts.map(acc => ModuleFE_User.cache.unique(acc?._id));
        return { accounts, users };
    }
    renderParticipants() {
        return _jsx(LL_H_C, { className: 'container-participants', children: this.state.participants.accounts.map((account, index) => renderParticipantIcon(this.state.participants.users[index], account)) });
    }
    renderTopicIdentifiers() {
        let topicEntity;
        try {
            topicEntity = ModuleFE_Discussion.getEntityNameFromTopic(this.props.discussion.topicId);
        }
        catch (e) {
            this.logError(`renderTopicLabel -> Failed rendering entity name for topic ${this.props.discussion.topicId} of discussion ${__stringify(this.props.discussion)}`, e);
            topicEntity = `Failed rendering topic entity name ${this.props.discussion.topicId}`;
        }
        let topicLabel;
        try {
            topicLabel = ModuleFE_Discussion.getLabelFromTopicId(this.props.discussion.topicId);
        }
        catch (e) {
            this.logError(`renderTopicLabel -> Failed rendering label for topic ${this.props.discussion.topicId} of discussion ${__stringify(this.props.discussion)}`, e);
            topicLabel = `Failed rendering topic label ${this.props.discussion.topicId}`;
        }
        return _jsxs(LL_V_L, { children: [_jsx("div", { className: 'topic-entity-name', children: topicEntity }), _jsx("div", { className: 'topic-label', onClick: this.focusManagerOfSelectedTopic, children: topicLabel })] });
    }
    focusManagerOfSelectedTopic = () => {
        const dbTopic = ModuleFE_Topic.cache.unique(this.props.discussion.topicId);
        if (!dbTopic)
            throw new BadImplementationException(`Couldn't find topic for id ${this.props.discussion.topicId}.`);
        if (dbTopic.type === 'variable')
            return;
        const searchItem = CollectionEntityMapper.getEntityMapByCollectionName(dbTopic.type);
        ModuleFE_RoutingV2.goToRoute(searchItem.route, { id: dbTopic.refId, type: dbTopic.type });
        dispatcher_urlParamsChanged.dispatchUI();
    };
    renderMessages() {
        const messagesToShow = this.state.discussionOpened ? this.state.messages : this.state.messages.slice(0, 1);
        if (!messagesToShow.length)
            return _jsx("div", { className: 'error-message-text', children: "Failed to find the first msg!" });
        return messagesToShow.map(message => _jsx(Message_Renderer, { messageId: message._id }, message._id));
    }
    renderShowRepliesButton() {
        const messageCount = ModuleFE_Message.cache.filter(msg => msg.topicId === this.props.discussion.topicId).length;
        const replyCount = messageCount - 1;
        return replyCount > 0 &&
            _jsx("div", { className: 'replies', onClick: () => {
                    this.reDeriveState({ discussionOpened: !this.state.discussionOpened });
                }, children: this.state.addingNewMessage ? _jsx(_Fragment, {}) : this.state.discussionOpened ? 'Show less' : `${replyCount} ${(replyCount > 1) ? 'replies' : 'reply'}` });
    }
    renderAddReply() {
        return _jsxs(LL_V_R, { className: 'add-message-container', children: [_jsx(TS_TextArea, { className: 'add-message-input', type: 'text', value: this.state.newMessageDraft, onChange: (value) => {
                        // @ts-ignore
                        this.setState({ newMessageDraft: value });
                    } }), _jsxs(LL_H_C, { className: 'add-message-button-container', children: [_jsx(Button, { variant: 'secondary', className: 'add-message-button-cancel', onClick: () => this.setState({ addingNewMessage: false, newMessageDraft: undefined }), children: "Cancel" }), _jsx(Button, { variant: 'primary', className: 'add-message-button-save', onClick: async () => {
                                if (!this.state.newMessageDraft)
                                    return;
                                await ModuleFE_Discussion.addMessageToDiscussion(this.props.discussion._id, this.state.newMessageDraft.trim());
                                this.setState({ newMessageDraft: undefined });
                            }, children: "Save" })] })] });
    }
    /////////////////////////////////// Main sections render ///////////////////////////////////
    renderLeft() {
        return _jsx(LL_V_C, { className: 'container-left', children: _jsx("div", { className: _className('resolved-status', this.props.discussion.status === 'resolved' ? 'resolved' : 'unresolved') }) });
    }
    renderMid() {
        return _jsxs(LL_V_L, { className: 'container-mid', children: [this.renderParticipants(), this.renderTopicIdentifiers(), this.renderMessages(), this.renderShowRepliesButton(), !this.props.disabled && this.state.addingNewMessage && this.renderAddReply()] });
    }
    renderRight() {
        return _jsxs(LL_V_L, { className: 'container-right', children: [_jsx(ICONS.v.component, { className: 'resolve-button', onClick: async () => {
                        if (!this.props.discussion)
                            return;
                        const newStatus = this.props.discussion.status === 'resolved' ? 'open' : 'resolved';
                        await ModuleFE_Discussion.v1.upsert({
                            ...this.props.discussion,
                            status: newStatus
                        }).executeSync();
                    } }), !this.state.addingNewMessage && _jsx(ICONS.messageBubble.component, { className: 'add-message-bubble', onClick: () => {
                        this.reDeriveState({
                            addingNewMessage: true,
                            discussionOpened: true
                        });
                    } })] });
    }
    onContextMenuClicked = (e) => {
        if (!this.props.discussion) {
            this.logWarning('Right-clicked, but did not receive the discussion!');
            return;
        }
        stopPropagation(e);
        const menuItems = [
            {
                label: 'Delete', onClick: () => {
                    TS_SimpleDialog.show({
                        title: 'Delete this discussion?',
                        body: _jsx(DeleteConfirmation_Body, { discussion: this.props.discussion }),
                        negativeButtonProps: { label: 'Cancel' },
                        actionButtonProps: {
                            label: 'Delete', action: async () => {
                                await ModuleFE_Discussion._v1.deleteDiscussion({ discussionId: this.props.discussion._id }).executeSync();
                            }
                        },
                    });
                }
            }
        ];
        const rightClickMenu = {
            id: 'discussion-right-click-menu',
            adapter: SimpleListAdapter(menuItems, renderer => _jsx("div", { className: 'node-data', children: renderer.item.label })),
            originPos: { y: e.clientY, x: e.clientX, },
            modalPos: { x: 0, y: 1 },
            onNodeClicked: (path, item) => {
                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                item.onClick?.();
            }
        };
        ModuleFE_MouseInteractivity.showMenu(rightClickMenu);
    };
    /////////////////////////////////// Render ///////////////////////////////////
    render() {
        if (!this.props.discussion)
            return;
        return _jsxs(LL_V_L, { className: 'discussion', children: [_jsxs(LL_H_C, { onContextMenu: this.onContextMenuClicked, children: [this.renderLeft(), this.renderMid(), !this.props.disabled && this.renderRight()] }), _jsx("div", { className: 'container-bottom-border-for-padding', children: _jsx("div", { className: 'discussion-bottom-border' }) })] });
    }
}
//# sourceMappingURL=Discussion_Renderer.js.map